import { default as AntdIcon } from '@ant-design/icons'

export const Icon = AntdIcon
